import { render, staticRenderFns } from "./linkModal.vue?vue&type=template&id=a82712a0&scoped=true"
import script from "./linkModal.vue?vue&type=script&lang=js"
export * from "./linkModal.vue?vue&type=script&lang=js"
import style0 from "./linkModal.vue?vue&type=style&index=0&id=a82712a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82712a0",
  null
  
)

export default component.exports